import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, DataTable, Button, Text, InlineStack } from "@shopify/polaris";
import ConfirmationModal from "../Common/ConfirmationModal";

import { PAGE_SIZE } from "../../constants/common-constants";
import { DeleteCoupon } from "../../services/coupons";
import { ToastContext } from "../../global-contexts/Toast";

const CouponTable = ({
  coupons,
  setCurrentPage,
  currentPage,
  fetchCoupons,
}) => {
  const navigate = useNavigate();

  const { setToast } = useContext(ToastContext);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);

  const handleDeleteClick = async (coupon) => {
    setSelectedCoupon(coupon);
    setModalOpen(true);
  };
  function capitalizeEachWord(str) {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  const handleUpdateClick = async (id) => {
    console.log(id);
    navigate(`/coupons/update/${id}`);
  };

  const handleConfirmDelete = async () => {
    try {
      const { _id: id } = selectedCoupon;
      await DeleteCoupon(id);
      setToast({
        error: false,
        message: "Successfully deleted the coupon",
        open: true,
      });
    } catch (e) {
      console.error(e);
      setToast({
        error: true,
        message: e.message || "Successfully deleted the coupon",
        open: true,
      });
    }
    fetchCoupons();
  };

  const rows = coupons.map((coupon) => {
    return [
      coupon.code,
      capitalizeEachWord(coupon.title),
      `${coupon.discountType === "percentage" ? "" : "₹"}${
        coupon.discountValue
      }${coupon.discountType === "percentage" ? "%" : ""}`,
      capitalizeEachWord(coupon.discountType?.split("_").join(" ")),
      capitalizeEachWord(coupon.appliesTo),
      coupon.usageLimit ?? "-",
      capitalizeEachWord(coupon.status),
      <InlineStack gap={"100"}>
        <Button
          onClick={() => {
            handleUpdateClick(coupon._id);
          }}
        >
          Update
        </Button>

        <Button
          onClick={() => {
            handleDeleteClick(coupon);
          }}
        >
          Delete
        </Button>
      </InlineStack>,
    ];
  });

  return (
    <Card>
      <DataTable
        hideScrollIndicator
        columnContentTypes={[
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
          "text",
        ]}
        headings={[
          <Text variant="headingSm"> Coupon Code</Text>,
          <Text variant="headingSm">Title</Text>,
          <Text variant="headingSm">Discount Value</Text>,
          <Text variant="headingSm">Discount Type</Text>,
          <Text variant="headingSm">Applies To</Text>,
          <Text variant="headingSm">Usage Limit </Text>,
          <Text variant="headingSm">Status </Text>,
          <Text variant="headingSm">Actions</Text>,
          // "Actions",
        ]}
        pagination={{
          hasNext: coupons.length >= PAGE_SIZE,
          onNext: () => {
            setCurrentPage(currentPage + 1);
          },
          onPrevious: () => {
            if (currentPage > 1) {
              setCurrentPage(currentPage - 1);
            }
          },
          hasPrevious: currentPage > 1,
        }}
        rows={rows}
      />
      {modalOpen && selectedCoupon && (
        <ConfirmationModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onConfirm={handleConfirmDelete}
          title="Confirm Deletion"
          message={`Are you sure you want to delete the coupon "${selectedCoupon.title}"? This action cannot be undone.`}
        />
      )}
    </Card>
  );
};

export default CouponTable;
